import React from 'react';
import { Modal, Box, Grid } from '@mui/material';

function ViewImageModal(props) {
  const { imageUrl, open, handleClose } = props;
  return (
    <Modal open={open} onClose={handleClose}>
      <Box className="modal-common enlarge-modal">
        <Grid container>
          <Grid item xs={12} md={12} lg={12} xl={12}>
            <img src={imageUrl} className="image-enlarge-modal" />
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}

export default ViewImageModal;
